module.exports = __webpack_public_path__ + "img/wp-new-habit-card19.f999f8a5.jpg";